import { addTooltipContainer } from "@/scripts/tool-tip.js";
import { initializeTeamCheckViz } from "@/scripts/team-check-viz.js";

export const renderPerformanceGraph = () => {
  initializeTeamCheckViz();
  addTooltipContainer();
};
